import { useEffect, useState } from 'react'

import { useMyMonitoringPingUnit } from '@apps-common/apis/my-monitoring/control'
import {
  AccountStatus,
  ConnectivityStatus,
  PingButton,
  ProductStatus,
  SignalStatus
} from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { ModalButton } from '@apps-common/components/modals'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { IMMSiteModel } from '@apps-common/types/my-monitoring'
import { DeviceStatus } from '@apps-common/utils/device-status'
import { StatusInfoMyMonitoringModal } from './StatusInfoMyMonitoringModal'

interface IProps {
  siteLoading?: boolean
  site?: IMMSiteModel
  itemClasses?: string
}

export const SiteStatusMyMonitoring = ({ siteLoading, site, itemClasses }: IProps) => {
  const { isLoading, isFetching, isRefetching, isError, data, refetch } = useMyMonitoringPingUnit({
    config: {
      enabled: !!site?.unitId
    },
    model: {
      unitId: site?.unitId || '',
      triggerType: '',
      onTime: 0,
      commands: []
    }
  })

  const [status, setStatus] = useState<DeviceStatus | undefined>()

  useEffect(() => {
    if (data && site) {
      const statusObj = new DeviceStatus(site.accountNo, site.productId, site.product, site.productImageUrl, data)

      setStatus(statusObj)
    }
  }, [data])

  const loading = !site || siteLoading || isLoading || isFetching || isRefetching

  return (
    <div className='relative w-full sm:w-auto inline-block px-[1rem] sm:px-0'>
      <ModalButton
        component={StatusInfoMyMonitoringModal}
        disabled={loading}
        classes='!opacity-100 relative flex items-center justify-between bg-ctx-surface/40 py-[2px] pl-[10px] pr-[10px] sm:pl-2 sm:pr-3 rounded-3xl overflow-hidden min-h-[54px] sm:min-h-[64px]'
        componentProps={{
          site
        }}
        // confirmCallback={(unitId: string) => callback(unitId)}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <ProductStatus
          loading={loading}
          data={status?.model || { imageUrl: site?.productImageUrl || '', name: site?.product || '' }}
          classes={itemClasses}
        />
        <AccountStatus loading={loading} isInactive={false} data={status?.accountNo || site?.accountNo} classes={itemClasses} />
        <ConnectivityStatus loading={loading} data={status?.online} classes={itemClasses} />
        <SignalStatus loading={loading} data={status?.signal} classes={itemClasses} />
        <div className='ml-2 h-full flex items-center justify-center gap-4'>
          <PingButton
            refetch={refetch}
            requestModel={{
              unitId: site?.unitId || '',
              triggerType: '',
              onTime: 0,
              commands: []
            }}
            disabled={loading}
            classes='bg-ctx-mm-brand text-ctx-on-mm-brand !min-w-[35px] !min-h-[35px]  sm:!w-[40px] sm:!h-[40px]'
          />
        </div>
      </ModalButton>
    </div>
  )
}
